import { PLAN_SKU_LIVE } from 'services/plans'

export const LIVE_ACCESS_SUBSCRIPTION_CODE = 290
export const UPGRADE_NOW_URL = '/account'
export const JOIN_NOW_URL = '/go'
export const JOIN_NOW_QUERY = {
  sku: PLAN_SKU_LIVE,
}

export const LIVE_CHANNEL_EMAIL_CAPTURE_KEY = 'Live-Channel'
export const EMAIL_CAPTURE_KEY_PREFIX = 'gaia-live-key_'
